export const imageBaseUrl = "https://image.tmdb.org/t/p/w500";
export const listBaseUrlpre ="https://api.themoviedb.org/3/discover/movie?api_key="
export const api_key = '32caee476494fffec113dfe33b606869'
export const listBaseUrlpost = "&language=en-US&sort_by=popularity.desc&include_adult=false&include_video=false&page="
///DO NOT FORGET TO ADD PAGE NUMBER///
